import { useCallback } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { useSearchParams } from '@/shared/hooks/useSearchParams';
import { QueryParameter } from '@/shared/constants/queryParams';

import { ALL_CHANNELS_ID } from '../constants';

export function useSetChannelCategoryTabQueryParam() {
    const router = useRouter();
    const searchParams = useSearchParams();

    return useCallback(
        (categoryId?: string) => {
            searchParams.set(QueryParameter.CHANNEL_CATEGORY_TAB, categoryId || ALL_CHANNELS_ID);
            router.navigate({
                to: router.location,
                meta: {
                    searchParams,
                },
                replace: true,
            });
        },
        [router, searchParams]
    );
}
